<template>
  <div class="overflow-hidden">
    <div class="services-details-area ptb-100">
      <div class="container mw-1356">
        <div class="row">
          <div class="col-lg-4">
            <SidebarWidget />
          </div>

          <div class="col-lg-8">
            <div class="services-details-content">
              <p>
                مرحباً بك في مركزنا المتكامل للترفيه الرقمي، حيث يلتقي البث عالي الجودة بالخدمة الاستثنائية، لنقدم لك تجربة مشاهدة لا مثيل لها. تم تصميم خدماتنا لتتجاوز الحدود التقليدية، وتصل بك إلى عالم واسع من المحتوى الترفيهي المباشر، مع التركيز الكامل على السرعة، الموثوقية، والابتكار المستمر.
              </p>

              <div class="mb-45"></div>

              <h3>لماذا تعتبر خدمتنا الأفضل في عالم البث؟</h3>
              <ul class="ps-0 list-unstyled services-list">
                <li class="d-flex align-items-center">
                  <i class="ti ti-circle-check"></i>
                  <span>تطبيق معايير أمنية متقدمة لحماية خصوصيتك وبياناتك أثناء المشاهدة.</span>
                </li>
                <li class="d-flex align-items-center">
                  <i class="ti ti-circle-check"></i>
                  <span>بث مباشر مستقر ومستمر دون أي تقطيع أو انقطاع مفاجئ.</span>
                </li>
                <li class="d-flex align-items-center">
                  <i class="ti ti-circle-check"></i>
                  <span>اتصال سلس وتوافق تام مع جميع الأجهزة الذكية.</span>
                </li>
              </ul>

              <p>
                في جوهر خدمتنا، التزامنا الدائم باستخدام أحدث تقنيات البث الرقمي، مما يضمن بقاءك في طليعة الثورة الترفيهية. مع جودة تصل إلى 4K، زمن استجابة منخفض جداً، وبنية تحتية قوية للسيرفرات، تضع خدمتنا حجر الأساس لتجربة مشاهدة مذهلة، تمكنك من الاستمتاع ببرامجك المفضلة، المباريات الرياضية، والأفلام بكل سهولة.
              </p>
              <p>
                سواء كنت محترفاً في التعامل مع التقنيات الحديثة، أو عائلة تبحث عن الترفيه المنزلي، أو حتى من كبار السن الذين يرغبون في تجربة ترفيهية بسيطة وممتعة، فقد صممنا باقاتنا لتلبي كافة توقعاتك واحتياجاتك.
              </p>

              <div class="mb-45"></div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="services-img">
                    <img src="@/assets/images/services-1.jpg" alt="services" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="services-img">
                    <img src="@/assets/images/services-2.jpg" alt="services" />
                  </div>
                </div>
              </div>

              <p>
                اختر مركزنا للخدمات الترفيهية لتستمتع بأكثر من مجرد خدمة بث؛ اختر بوابة لعالم يتقاطع فيه الابتكار والموثوقية ورضا العميل لإعادة تعريف مفهومك عن الترفيه الرقمي في العصر الحديث.
              </p>

              <div class="mb-45"></div>

              <ExploreSpeeds />

              <div class="mb-45"></div>

              <h3 class="mb-4">آراء عملائنا حول خدمات البث</h3>

              <OurInternetServicesReviews />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SidebarWidget from "./SidebarWidget.vue";
import ExploreSpeeds from "./ExploreSpeeds.vue";
import OurInternetServicesReviews from "./OurInternetServicesReviews.vue";

export default defineComponent({
  name: "ServicesDetails",
  components: {
    SidebarWidget,
    ExploreSpeeds,
    OurInternetServicesReviews,
  },
});
</script>